import GlobalPartner from '../icons/global-partner.svg';
import Dialogue from '../icons/dialogue.svg';
import HeatMap from '../icons/heat-map.svg';
import CalenderDate from '../icons/calendar-date.svg';
import LogoSymbolColor from '../icons/uiLogoSymbolColor.svg';
import NetworkIcon from '../icons/network.svg';
import SWXAutomateIcon from '../icons/swxAutomateIcon.svg';

import HighRiskUsers from '../icons/highRiskUsers.svg';

const customIcons = {
  GlobalPartner,
  Dialogue,
  HeatMap,
  CalenderDate,
  LogoSymbolColor,
  NetworkIcon,
  SWXAutomateIcon,
  HighRiskUsers
};

export {
  GlobalPartner,
  Dialogue,
  HeatMap,
  CalenderDate,
  LogoSymbolColor,
  NetworkIcon,
  HighRiskUsers
};

export default customIcons;
